export default "__VITE_ASSET__1rYuBc0d__"